import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

export const sendEntityKYCFormDataAction = async (payload) => {
  try {
    //  console.log ("[InsertKYC] payload:", {
    //     entityPrimaryId: payload.entityPrimaryId,
    //     kycId: payload.kycId,
    //     entityType: payload.entityType,
    //     isSaveAsDraft: payload.isSaveAsDraft,
    // });

    const response = await apiClient.post(
      ATP_API_URL.KYC_FORM_FIELDS_DATA,
      payload,
    );

    if (response?.status === 200) {
      if (response.data?.success === false) {
        return {
          success: false,
          error: response.data?.message || "Failed to submit KYC",
          message: response.data?.message,
        };
      }
      return {
        success: true,
        data: response.data,
        message: response.data?.message || "KYC submitted successfully",
      };
    }

    return {
      success: false,
      error: response?.data?.message || "Failed to submit KYC",
    };
  } catch (error) {
    console.error("[InsertKYC] error:", error);
    return {
      success: false,
      error: error.message || "Failed to submit KYC",
    };
  }
};
